import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { selectBookingRecordId } from 'src/store/slices/booking-slice';

import { checkBookingStatus } from '../../api/bookingService/requests';

export const useCheckBookingStatus = () => {
    const REFETCH_INTERVAL_MS = 3000;
    const BOOKING_RECORD_PARAM = 'booking';

    const [searchParams] = useSearchParams();
    const paramsBookingRecordId = searchParams.get(BOOKING_RECORD_PARAM);
    const storedBookingRecordId = useSelector(selectBookingRecordId);
    const hasStoredBookingRecordId =
        storedBookingRecordId !== null && storedBookingRecordId.length > 0;
    const hasParamsBookingRecordId =
        paramsBookingRecordId !== null && paramsBookingRecordId.length > 0;

    const bookingRecordId = paramsBookingRecordId || storedBookingRecordId;

    const query = useQuery({
        enabled: hasParamsBookingRecordId || hasStoredBookingRecordId,
        queryFn: () => checkBookingStatus(bookingRecordId as string),
        queryKey: ['booking', 'status'],
        refetchInterval: REFETCH_INTERVAL_MS,
    });

    return {
        query,
    };
};
